import axios from '@/utils/request'
import utils from '@/utils/index.js'
var Qs = require('qs')

export default {
	states_all: ['newly', 'dispatched', 'processing', 'processed', 'finished', 'canceled'],
	order_types: ['custom', 'remake', 'bulk'],
	passRange: [
		{ label: '1天', key: 'pass1', condition: { passRangeStart: 1, passRangeEnd: 1 } },
		{ label: '2天', key: 'pass2', condition: { passRangeStart: 2, passRangeEnd: 2 } },
		{ label: '3天', key: 'pass3', condition: { passRangeStart: 3, passRangeEnd: 3 } },
		{ label: '4-7天', key: 'pass-4-7', condition: { passRangeStart: 4, passRangeEnd: 7 } },
		{ label: '全部', key: 'pass-all', condition: { passRangeStart: 1, passRangeEnd: 1000 } }
	],
	nearRange: [
		{ label: '今天', key: 'near-today', condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(new Date())) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(new Date())) + ' 23:59:59' } },
		{ label: '明天', key: 'near-tomorrow', condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(1))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(1))) + ' 23:59:59' } },
		{ label: '后天', key: 'near-datmr', condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(2))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(2))) + ' 23:59:59' } },
		{ label: '4-7天', key: 'near-4-7', condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(3))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(6))) + ' 23:59:59' } },
		{ label: '本周', key: 'near-week', condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.beginOfThisWeek())) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfThisWeek()) + ' 23:59:59' } }
	],
	// 2020-10-16
	findByUuid(params) {
		return axios.get('/mes/orders/find-by-uuid', params)
	},
	// 2020-10-31  挂单查订单
	findSameSpecReplenishs(params) {
		return axios.get('/mes/orders/find-same-spec-replenishs', params);
	},
	// 2020-10-31
	unDealHangOrdersByUuid(uuid) {
		return axios.get('/mes/orders/' + uuid + '/un-deal-hang-orders-by-uuid');
	},
	// 2020-12-21
	search(params) {
		return axios.get('/mes/orders?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2020-12-25
	trackingSearch(params) {
		return axios.get('/mes/orders/tracking?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2020-12-21
	// specJson craftwork remark
	simpleUpdate(id, params) {
		return axios.put('/mes/orders/' + id + '/simple-update', params)
	},
	// 2021-01-15
	updateRemark(id, params) {
		return axios.put('/mes/orders/' + id + '/update-remark', params)
	},
	// 2023-03-31
	updateMaterialRemark(id, params) {
		return axios.put('/mes/orders/' + id + '/update-material-remark', params)
	},
	// 2025-05-25
	updateCostPrice(id, params) {
		return axios.put('/mes/orders/' + id + '/update-cost-price', params)
	},
	// 2025-06-17
	batchUpdateCostPrice(params) {
		return axios.put('/mes/orders/batch-update-cost-price', params)
	},
	// 2020-12-21
	updateGroup(id, params) {
		return axios.put('/mes/orders/' + id + '/update-group', params);
	},
	// 2020-12-21
	batchUpdateGroup(params) {
		return axios.put('/mes/orders/batch-update-group', params);
	},
	// 2020-12-21
	changeFactory(params) {
		return axios.put('/mes/orders/change-factory', params)
	},
	// 2020-12-21
	exportExcel(params) {
		return axios.get('/mes/orders/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2020-12-21
	phasePlansByOrderUuid(params) {
		return axios.get('/mes/orders/phase-plans/find-by-order-uuid', params)
	},
	// 2020-12-21
	phasePlansCreate(params) {
		return axios.post('/mes/orders/phase-plans', params)
	},
	// 2020-12-21
	phasePlanUpdate(phasePlanId, params) {
		return axios.put('/mes/orders/phase-plans/' + phasePlanId, params)
	},
	// 2021-01-11
	phasePlanSwapSequence(params) {
		return axios.put('/mes/orders/phase-plans/swap-sequence', params)
	},
	// 2020-12-21
	phasePlanDelete(phasePlanId) {
		return axios.delete('/mes/orders/phase-plans/' + phasePlanId)
	},
	// 2020-12-21
	phaseMakesFindByPhasePlanId(phasePlanId, params) {
		return axios.get('/mes/orders/phase-makes/find-by-phase-plan-id/' + phasePlanId, params)
	},
	// 2020-12-21
	cancel(id, params) {
		return axios.put('/mes/orders/' + id + '/cancel', params)
	},
	// 2020-12-21
	pause(id) {
		return axios.put('/mes/orders/' + id + '/pause')
	},
	// 2020-12-21
	reManufacture(id) {
		return axios.put('/mes/orders/' + id + '/re-manufacture')
	},
	// 2020-12-21
	manualDispatch(params) {
		return axios.put('/mes/orders/manual-dispatch', params)
	},

	// 2021-03-01
	reManualDispatch(params) {
		return axios.put('/mes/orders/re-manual-dispatch', params)
	},

	// 2020-12-22
	pendingDispatchSearch(params) {
		return axios.get('/mes/orders/pending-dispatch-search?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2020-12-22
	updateWorkOrderSn(id, params) {
		return axios.put('/mes/orders/' + id + '/update-work-order-sn', params)
	},
	// 2020-12-22
	findByWorkOrderSn(params) {
		return axios.get('/mes/orders/find-by-work-order-sn', params)
	},
	// 2020-12-22
	autoDispatch(params) {
		return axios.put('/mes/orders/auto-dispatch', params)
	},
	// 2020-12-22
	manualDispatch(params) {
		return axios.put('/mes/orders/manual-dispatch', params)
	},
	// 2020-12-26
	workbenchQtyCount() {
		return axios.get('/mes/orders/workbench-qty-count')
	},
	// 2020-12-27
	processingPhaseCount() {
		return axios.get('/mes/orders/phase-plans/processing-phase-count');
	},
	// 2020-12-27
	unSettle(params) {
		return axios.get('/mes/orders/un-settle?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2020-12-27
	findBySettlementId(settlementId) {
		return axios.get('/mes/orders/find-by-factory-settlement-id/' + settlementId);
	},
	// 2020-12-27
	clearSettle(id) {
		return axios.delete('/mes/orders/' + id + '/clear-settle');
	},
	// 2020-12-27
	updateFactorySettlement(id, params) {
		return axios.put('/mes/orders/' + id + '/update-factory-settlement', params);
	},
	// 2020-12-27
	exportExcelByFactorySettlementId(settlementId) {
		return axios.get('/mes/orders/export-excel-by-factory-settlement-id/' + settlementId);
	},

	// 2020-12-28
	pendingDispatchCount() {
		return axios.get('/mes/orders/pending-dispatch-count');
	},

	// 2021-03-01
	asyncPhaseToPdm(id) {
		return axios.put('/mes/orders/' + id + '/async-phase-to-pdm')
	},

	// 2021-07-22
	packAutoDispatch(params) {
		return axios.put('/mes/orders/pack-auto-dispatch', params)
	},

	// 2021-07-23
	packManualDispatch(params) {
		return axios.put('/mes/orders/pack-manual-dispatch', params)
	},
	// 2021-12-03
	calcExpectHandOver(params) {
		return axios.get('/mes/orders/calc-expect-hand-over', params)
	},

}